module.exports = __webpack_public_path__ + "assets/img/33_836.5e31051f.jpg";